export class CommonFunction {
  /**
   * [PSSR-3152] Incorrect DOB
   *
   * Issue:
   * The Date is converted from the local machine's timezone to UTC+0 before it
   * is sent to the backend. The backend then converts it to Malaysia time (UTC+8).
   * If the machine timezone is ahead of +8 (e.g. Japan +9), the date goes back 1 day:
   * Pick 1 Sep 00:00 (+9) -> 31 Aug 15:00 UTC -> backend +8 -> 31 Aug 23:00
   *
   * Fix:
   * Always send the date picked on the calendar as UTC+0 midnight, whatever the
   * machine timezone is, e.g. "2026-09-01T00:00:00.000Z".
   *
   * Applied to:
   * 1. Customer Info DOB: backend converts to UTC+8, stored as 1 Sep 08:00
   * 2. Additional Driver DOB: backend stores the value as sent, stored as 1 Sep 00:00
   *
   * @param date the picked Date to convert, or null/undefined if not set
   * @returns a UTC-midnight ISO string, e.g. "2026-09-01T00:00:00.000Z", or null
   */
  static toCalendarDateUtc(date?: Date | null): string | null {
    if (date == null) return null;

    const d = new Date(date);

    const pad = (n: number) => String(n).padStart(2, "0");
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());

    return `${year}-${month}-${day}T00:00:00.000Z`;
  }
}
